export default __webpack_public_path__ + "static/media/facial-treatment-black.082c24d2.svg";